export default {
  onefid: "ONEFID",
  telephone: "+ 49 221 95793412",
  "how to use": "HOW TO USE",
  "customer support": "CUSTOMER SUPPORT",
  catalog: "CATALOG",
  start: "START",
  back: "BACK",
  goBack: "GO BACK",
  next: "NEXT",
  "new scan": "NEW SCAN",
  home: "HOME",
  "no scanner found": "No 3D scanners found.",
  "detect scanner message": "detecting 3D scanners in progress",
  yes: "YES",
  no: "NO",
  measurements: "measurements",
  analysis: "analysis",
  more: "more",
  "new user": "New user",
  "new scan modal logged in user": "This user is logged in\ndo you want to create\nnew scan or log out?",
  "new scan modal not logged in user": 'You clicked on  "NEW SCAN"\nthis will overwrite the current results.\nPlease choose the next action.',
  "save result": "Save result",
  weight: "WEIGHT",
  activity: "ACTIVITY",
  searchPlaceHolder: "What are you looking for?",
  loadProductMessage: "Please wait while the product catalogue is being loaded. This may take some time...",
  noProductFoundMessage: "Sorry, no products were found matching your size!",
  noSearchProductFoundMessage: "Sorry, no products were found matching your search",
  resetFilter: "reset filter",
  loadMoreProducts: "Load more products!",
  "make new search": "make new search",
  "In stock": "In stock",
  projectedStock: "Projected stock",
  "out of stock": "out of stock",
  SAVE: "SAVE",
  FEEDBACK: "FEEDBACK",
  "order now": "ORDER NOW",
  price: "Price",
  noInternet: "We could not detect an Internet connection. Please check",
  moreDetails: "more Details",
  recommendedForYou: "RECOMMENDED FOR YOU",
  addItem: "Add item",
  mainScreen: "Main Screen",
  createInsole: "Create Insole",
  insoleCreation: "Insole creation is in progress",
  shoeSize: "Size",
  insoleType: "Insole type",
  recommendedInsole: "Recommended Insole: ",
  sport: "Sport",
  everyday: "Everyday",
  chooseCustomer: "CHOOSE CORPORATE CLIENT",
  createEvent: "CREATE EVENT",
  createButton: "CREATE",
  chooseButton: "SELECT",
  adjustSize: "ADJUST SIZE",
  comments: "Comments",
  createProcess: "Create Process",
  "legLengthCompensation1,5cm": "LEG LENGTH COMPENSATION UP TO 1.5 CM",
  legLengthCompensation3cm: "LEG LENGTH COMPENSATION UP TO 3 CM",
  inOutEdgeElevation: "INNER-/OUTER EDGE ELEVATION",
  corkWedge: "CORK WEDGE",
  haglundFerse: "HAGLUND DEFORMITY",
  wheelingSole: "ROLLER",
  butterflyRoll: "BUTTERFLY ROLLER",
  orthoOrderSuccessMessage: "We successfully\nsaved your Orthopedic shoe & insole adaptions",
  orthopedicInsole: "ORTHOPEDIC INSOLE",
  changeSizeButton: "Select size",
  shoeAdaptionsModalTitle: "Adjustments",
  listOfSizes: "List of sizes",
  orthoOrder: "Ortho Order",
  shoeFitting: "SHOE FITTING",
  fullCatalog: "COMPLETE CATALOG",
  accessoriesCatalogTitle: "Accessories",
  repeatScanButton: "Repeat Scan",
  items: "Items",
  removeButton: "remove",
  checkoutButton: "checkout",
  cartIsEmpty: "Cart is Empty",
  orthoInsolePopupText: "Only one orthopedic insole is allowed per order.",
  closeButton: "Close",
  customInsole: "Custom Insole",
  itemsInCartWarning: "There are still items in the cart that have not been completed.\nContinue anyway?",
  cartButton: "Cart",
  white: "White",
  black: "Black",
  selectLanguage: "Select Language",
  sizeRecommendation: "Size Recommendation",
  printButton: "FINALISE AND PRINT",

  newScan: {
    headlines: {
      mode: "mode",
      confirmation: "confirm",
    },
    origin: "REGION OF ORIGIN",
    "north-america": "North America",
    "south-america": "South America",
    europe: "Europe",
    africa: "Africa",
    asia: "Asia",
    oceania: "Oceania",
    birthdate: "YEAR OF BIRTH",
    birthdateQuestion: "Please select your year of Birth",
  },
  gender: {
    caption: "gender",
    female: "female",
    male: "male",
    diverse: "diverse",
  },
  mode: {
    caption: "mode",
    barefoot: "barefoot",
    socks: "socks",
    dark_socks: "dark socks",
    bright_socks: "bright socks",
  },
  auth: {
    login: "login",
    register: "register",
    confirm: "confirm",
    connect: "connect",
    createAccount: "create account",
    logIn: "log in",
    logOut: "log out",
    addEmail: "Add email",
    changeEmail: "Change email",
    stayConnected: "stay connected",
    logoutMessage: "This user is logged in\ndo you want to log out?",
    passwordPlaceholder: "Enter your Password",
    emailPlaceholder: "Enter your Email",
    employeenumberPlaceholder: "Enter your Employee number",
    emailRequired: "Email address is required.",
    emailInvalid: "Email address is invalid.",
    passwordRequired: "Password is required.",
    firstNameRequired: "First name is required.",
    lastNameRequired: "Last name is required.",
    dateOfBirthRequired: "Date of birth is required.",
    employeeNumberRequired: "Employee Number is required.",
    unableToLogin: "Unable to log in with provided credentials",
    emailExists: "email user with this email already exists.",
    employeeNumberExists: "A user with the same employee number exists.",
    unique: "email user with this email already exists.",
    confirmEmailAddedMessage: "Your email has been added",
    addEmailInfo: "Add your email to access your data in all supported platforms",
    emailAddedInstructions: "You will receive an email shortly to set a password",
    provideAllFields: "Please fill in all fields",
    genericError: "An error occurred, please try again in a few moments.",
    succesRegisterMessage: ["We successfully\nsaved your One", "Fitting", "ID"],
    shoepassionSuccesRegisterMessage: ["We successfully\nsaved your ", "Shoepassion", "ID"],
    confirmRegisterMessage: ["Your", "One Fitting ID", "account has been created! Just click on the link we sent you to confirm and get free access", "anytime anywhere"],
    shoepassionConfirmRegisterMessage: ["Your", "ShoepassionID ", "account has been created! Just click on the link we sent you to confirm and get free access", "anytime anywhere"],
    termsAndConditions: ["I've read and accept the", "Data protection regulations"],
    oneFittingIDCreation: "One Fitting ID creation",
    shoepassionNewsletter: ["register to Shoepassion Newsletter and accept", ""],
  },

  support: {
    caption: "System",
    selectScanner: "select scanner",
    calibration: "calibration",
    form: {
      textPlaceholder: "Describe the problem",
      namePlaceholder: "Full name",
      sendButtonText: "send",
    },
    bottomCards: {
      customerSupport: {
        caption: "customer support",
        phoneNumber: "OneFID: 06192 7755566",
        emailAddress: "scanner-support@onefid.com",
      },
      scannerId: {
        caption: "scanner id",
      },
    },
  },
  scan: {
    captionLeft: "PLEASE PUT YOUR LEFT FOOT ON",
    succescaptionLeft: "LEFT FOOT SCANNED",
    captionRight: "PLEASE PUT YOUR RIGHT FOOT ON",
    captionRightBirkenstock1: "We are creating your\nBIRKENSTOCK scan",
    captionRightBirkenstock2: "You can step off the scanner.\nYour scan data will be ready in few seconds!",
    secondarySizeRecommendationBirkenstock: "Your measurements fall between two sizes, you might also like to try a",
    succescaptionRight: "RIGHT FOOT SCANNED",
    captionMulti: "PLEASE PUT BOTH YOUR FEET ON",
    succescaptionMulti: "BOTH YOUR FEET SCANNED",
    start: "START",
    left: "LEFT FOOT",
    right: "RIGHT FOOT",
    both: "BOTH FEET",
    inProgress: "SCAN IN PROGRESS",
    setParameter: "SETTING UP CAMERA",
    capture: "CAPTURING FEET",
    process: "PROCESSING 3D SCAN",
    keepStill: "Please keep still",
    instructions: "Instructions",
    rollUpLegwear: "Roll-up your legwear so that nothing is inside the scanner",
    positionFeet: "Place your foot in front the line",
    distributeWeight: "Distribute your weight evenly across both feet and stand still",
    succesScanMessage: ["SCAN SUCCESSFUL", "We are creating your", "One", "FID", "BIRKENSTOCK", "scan", "You can step off the scanner.\nYour scan data will be ready in a few seconds!"],
    faildScanMessage: [
      "SCAN FAILED",
      "We did not succeed creating your One",
      "FID",
      "scan.",
      "There seems to be a problem. Please try again.\nContact us if the problem did not get resolved.",
      "SCAN AGAIN",
      "CANCEL",
    ],
    error: {
      title: "Unfortunately, something did not work.",
      callSupport: "If this does not solve the problem, please contact support.",
      genericError: "An error occurred.",
      scannerBusy: "Scanner is busy, please scan again in few seconds",
      foamBoxNotImplemented: "An error occurred.",
      log_output_too_short: "An error occurred.",
      an_error_occured: "An error occurred.",
      make_missing_target: "Please contact support.",
      incompatible_configuration_file: "Please contact support.",
      light_hardware_not_accessible: "Please switch off the scanner and switch it on again after ten seconds. Then repeat the measurement.",
      camera_initialization_fails: "A sensor error has occurred. Please wait for the scanner to reset and then repeat the measurement.",
      camera_provides_no_frames: "A sensor error has occurred. Please wait for the scanner to reset and then repeat the measurement.",
      meshlab_subdivision_surface_fails: "Please leave the scanner, clean the glass plate, roll up your trousers again if necessary, place your feet on the scanner and repeat the measurement.",
      meshlab_error: "Please leave the scanner, clean the glass plate, roll up your trousers again if necessary, place your feet on the scanner and repeat the measurement.",
      foot_length_unexpected: "Please leave the scanner, clean the glass plate, roll up your trousers again if necessary, place your feet on the scanner and repeat the measurement.",
      foot_width_unexpected: "Please leave the scanner, clean the glass plate, roll up your trousers again if necessary, place your feet on the scanner and repeat the measurement.",
      glass_plate_covered: "Please clear the glass plate.",
      foot_touches_bounding_volume: "Please position the feet according to the marking.",
    },
  },
  insole: {
    caption: "INSOLE",
    marketingText: "Base upon the foot analysis we recommend additional support with an insole.\nThis prevents fatigue and overloading.",
    q1caption: "Do you have pain in your feet?",
    q2caption: "Do you wear orthopedic insoles or are you undergoing orthopedic treatment due to foot problems?",
    q3caption: "Results",
    insoleTypeRequired: "Insole type is required",
    sizeRequired: "Size is required!",
    recommendation: {
      button: "CATALOG",
      0: {
        mainMessage: `No insole needed`,
        subMessage: "Based upon our foot analysis you do not have any foot malpositioning.",
        conclusion: "NO INSOLE RECOMMENDED",
      },
      1: {
        mainMessage: "Please consult with an orthopedic doctor",
        subMessage: "Based upon our foot analysis we recommend a detailed consultation by an orthopedist or podiologist!",
        conclusion: "INDIVIDUAL INSOLE NEEDED",
      },
    },
  },
  MeasurementScale: {
    foot_type: "foot type",
    heel_angle: "heel angle",
    arch_height: "arch height",
    foot_width: "foot width",
    flat: "Flat",
    normal: "Normal",
    high: "High",
    low: "Low",
    pronation: "Pronation",
    neutral: "Neutral",
    supination: "Supination",
    narrow: "Narrow",
    wide: "Wide",
    millimeters: "millimeters",
    cm: "centimeter",
    length: "length",
    width: "width",
    left: "left",
    right: "right",
    heightInstepPoint: "Height instep",
    widthHeel: "Width heel",
  },
  Order: {
    confirmMessage: "Are you sure you want to continue the order process",
    successMessage: "Your order was successfully submitted!",
    failureMessage: "Something went wrong! trying to process your order.",
    cotaFailureMessage: "You order Limit is reached you can not order this shoe!",
    success: "Success",
  },
  CustomiseProduct: {
    confirmCustomisation: "Do you want customise your shoe?",
    weight: {
      upto65Kg: "up to 65 Kg",
      from110Kg: "from 110 Kg",
    },
    activity: {
      mostlyStanding: "Mostly Standing",
      mostlyWalking: "Mostly Walking",
      mostlySitting: "Mostly Sitting",
    },
  },
  SafetyCatalog: {
    title: "Safety catalog",
    "work shoe": "WORK SHOE",
    "work boot": "WORK BOOT",
    "work sandal": "WORK SANDAL",
  },
  RunningCtalog: {
    title: "Running Catalog",
    runningExperience: "RUNNING EXPERIENCE",
    runningExperienceQuestion: "What's your running experience?",
    occasionally: "Occasionally (1-2x)",
    regularly: "Regularly (2-3x)",
    ambitious: "Ambitious (>3x)",
    application: "USAGE",
    applicationQuestion: "What do you want to use the shoe for?",
    walking: "Walking",
    competition: "Competition",
    training: "Training",
    terrain: "TERRAIN",
    terrainQuestion: "Where do you want to run?",
    trail: "Trail/Offraod",
    road: "Road / Treadmill",
    track: "Running track",
    knee: "KNEE AXIS",
    kneeQuestion: "How is your knee axis oriented?",
    concave: "In-knee (valgus)",
    neutral: "Neutral",
    convex: "Out-knee (varus)",
    heel: "HEEL ANGLE",
    heelQuestion: "How does you heel behave during running?",
    pronation: "Inside (Pronation)",
    neutralheel: "Neutral",
    supination: "Outside (Supination)",
    cushioning: "CUSHIONING",
    cushioningQuestion: "Which cushioning experience do you prefer?",
    soft: "Soft",
    hard: "hard",
    natural: "Natural running",
    normal: "Normal",
    ageGroup: "AGE GROUP",
    ageGroupQuestion: "What's your age group?",
    kids: "Kids",
    adults: "Adults",
    noProducts: "No Products",
    filterCriteriaMessage: "Please change your search criteria or change the filter settings.",
    resetFilter: "Reset filter",
  },
  SkiCatalog: {
    title: "Ski Catalog",
    skill: "SKILL",
    skillQuestion: "What's your Ski experience?",
    beginner: "Beginner",
    intermediate: "Intermediate",
    expert: "Expert",
    race: "Race",
    terrain: "TERRAIN",
    terrainQuestion: "Where do you want to ski?",
    allmontain: "All Mountain",
    piste: "Piste",
    freeride: "Free Ride",
    hard: "Hard",
    weight: "Weight",
    weightQuestion: "What's your weight?",
    upto60: "up to 60 kg",
    "60to80": "60 to 80 kg",
    "80to100": "80 to 100 kg",
    morethan100: "More than 100 kg",
    ageGroup: "AGE GROUP",
    ageGroupQuestion: "What's your age group?",
    kids: "Kids",
    adults: "Adults",
    noProducts: "No Products",
    filterCriteriaMessage: "Please change your search criteria or change the filter settings.",
    resetFilter: "Reset filter",
  },
  FilterCatalog: {
    title: "Filter Options",
    category: " Category",
    brand: "Brand",
    color: "Color",
    leahtherType: "Leather Type",
    underground: "Terrain",
    support: "Support",
    sale: "Sale",
    showProducts: "show products",
  },
  secondaryRecommendatiom: {
    yourSize: "YOUR SIZE",
    message1: "Your foot length is on the edge of two sizes which both fit you!",
    message2: "If you like your shoes to fit tight, choose: ",
    message3: "If you like your shoes to fit loose, choose: ",
  },
  expiviConfigurator: "Shoe Configurator",
  advertisingOnefid: "OneFID - Scan your feet and find shoes that fit",
  consents: {
    title: "FOOT SCANNING - CONSENT",
    agreeText: "I agree to the described processing of my data.",
    germanyConsent1: [
      "By using the foot scanner, you agree that BIRKENSTOCK Product GmbH may use the scan data collected during the foot scanning process for the purposes selected by you below. Your consent is always voluntary and can be withdrawn at any time with future effect by sending an email to ",
      "privacy@birkenstock.com",
      ", quoting your scan ID, which you will receive from us with today's scan.",
    ],
    germanyConsent2: ["Further details can be found in the ", "privacy policy"],
    germanyConsent3: [
      "Scan data",
      "I agree that my scan data (e.g., foot measurement data and 3D model, age, gender, region, timestamp, scan ID) may be processed in order to provide me with a size recommendation for BIRKENSTOCK products, and that the data may be pseudonymized for the research and development of BIRKENSTOCK products (e.g., footbeds) and that the scan data may be used for this purpose and passed on to other BIRKENSTOCK companies (in particular Birkenstock Group B.V. & Co. KG) and research companies (e.g. universities).",
      "We do not store your scan data under a name; instead we store it pseudonymized under an identifier. If you would like to delete your scan data, please notify us explicitly, stating your scan ID, which you received on the day of the scan.",
    ],
    germanyConsent4: [
      "Connection of the scan result to your customer account",
      "We offer you the option of connecting your scan results with your BIRKENSTOCK customer account. By connecting the scan results with your BIRKENSTOCK customer account, you agree that BIRKENSTOCK Europe GmbH may use the personal data collected during the scanning process (e.g., foot measurement data and 3D model, age, gender, region, timestamp, scan ID) for this purpose.",
      "I agree to my scan data being linked to my BIRKENSTOCK account. Details on the processing of your personal data in connection with your Birkenstock account can be found in our ",
    ]
  },
  privacyPolicy: {
    title: "Privacy Notice - Foot Scans",

    intro: "This privacy policy contains information for all participants regarding how we use data for our foot scans. If you have any questions, please do not hesitate to contact privacy@birkenstock.com.",

    sections: {
      what: {
        title: "1- WHAT?",
        body: "We process the following information when we scan your feet:",
        list: ["Age", "Gender", "Region", "Foot measurement data and 3D model (measurements and images)", "Date and time of scan", "Scan ID", "Email address (optional)"],
        footer:
          "The data is stored in our system in pseudonymized form under a cryptic ID.\nNo pictures are taken of your foot. Anatomical changes can be identified, but are not stored together with any personal data. Papillary lines, scars, and tattoos are not visible on the scan.",
      },

      why: {
        title: "2- WHY?",
        body: "We use this foot scanner in order to offer you an accurate size recommendation for your footwear. We additionally use the pseudonymized scan data for research and development purposes relating to BIRKENSTOCK products (e.g. footbeds). If you wish, we can also use your data to link your measurements to your BIRKENSTOCK account.",
      },

      who: {
        title: "3- WHO?",
        body: 'We are jointly responsible for processing your data. We have entered into an agreement that regulates our responsibilities as joint controllers. When we say “we” or “BIRKENSTOCK,” we are referring to the following companies:',
        company1: {
          name: "Birkenstock Product GmbH",
          address: ["Burg Ockenfels", "53545 Linz am Rhein", "Germany"],
          responsibility: "Responsible for your inquiries regarding data protection (see section (6) below) and for providing you with information about the processing of your data. You can, of course, also contact the other responsible company at any time."
        },
        company2: {
          name: "Birkenstock Europe GmbH",
          address: ["Burg Ockenfels", "53545 Linz am Rhein", "Germany"],
          responsibility: "",
        },
        dpo: {
          title: "You can reach our data protection officer at the following address:",
          name: "Birkenstock Product GmbH",
          address: ["Burg Ockenfels", "53545 Linz am Rhein", "Germany"],
          email: "dpo@birkenstock.com",
        },
        processors:[
          "Other companies that likewise belong to the BIRKENSTOCK Group may assist us with the processing of your data, in particular Birkenstock Group B.V. & Co. KG, which helps to run and maintain our IT systems as well as support in legal matters.",
          "If you link your scan data to your BIRKENSTOCK customer account, the data shall be shared with other BIRKENSTOCK companies, in particular with Birkenstock Europe GmbH as the operator of the online shop, to which your customer account belongs. Information regarding data processing in this context can be found here: "
        ],
        processorsLinkText: "Privacy Policy | BIRKENSTOCK",
        processorsLinkURL: "https://www.birkenstock.com/de-en/privacy-policy/legal-privacy.html",
        provider: "We draw on the services of OneFID GmbH, Matthias-Brüggen-Str. 4, 50827 Köln, Germany, to scan, analyze, and store the information.",
        transfer: {
          intro:
            "A number of our service providers and Group companies that potentially receive information regarding you from us are domiciled outside of the European Union (EU). These countries do not necessarily have a level of data protection which is comparable to that of the GDPR. If a recipient of your data is located outside of the EU, there are two ways in which to ensure that an adequate level of protection for your data is also guaranteed outside of the EU:",
          list: [
            "If a recipient is based in a country which the European Commission has determined has an adequate level of data protection, we rely on this adequacy decision of the European Commission. The European Commission provides an overview of the countries for which adequacy decisions have been made, and this",
            "If a recipient is based in a country for which the European Commission has not determined an adequate level of data protection, we either conclude a contract with this recipient in which we agree upon rules to ensure that the recipient adequately protects your personal data (the standard contractual clauses developed by the European Commission) or we rely on the binding corporate regulations of a group of companies or a company already approved by a supervisory authority. For more information, please contact us using the contact details provided in Section Fehler! Verweisquelle konnte nicht gefunden werden. of this privacy policy.",
          ],
          linkText: "can be viewed here.",
          link: "https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en?prefLang=de&etrans=de",
          outro: "You can request further information by contacting us under the contact details provided in section (3) of this Privacy Policy.",
        },
      },

      legal: {
        title: "4- ON WHAT BASIS?",
        body: "The legal basis for the processing of your data is your consent pursuant to point (a) of Article 6 (1) of the General Data Protection Regulation (GDPR).",
      },

      retention: {
        title: "5- FOR HOW LONG?",
        body: "Your data shall be stored until you revoke your consent or until the data are no longer needed for the necessary purpose.",
      },

      rights: {
        title: "6- YOUR RIGHTS",
        subtitle: "When we process your data, you have the following rights as per the GDPR:",
        list: [
          "Right of access",
          "Right to obtain confirmation:",
          "Right to rectification",
          'Right to erasure ("right to be forgotten")',
          "Right to restriction",
          "Right to data portability",
          "Right to lodge a complaint",
          "Right to withdrawal",
          "Right against a decision based on automated processing",
          "Right to object",
        ],
        explanations: [
          "You have a right of access regarding the processing of your personal data (Art. 13 and 14 GDPR).",
          "You have the right to obtain confirmation as to whether or not we are processing your personal data and, where that is the case, the right to obtain access to the personal data (Art. 15 GDPR).",
          "You have the right to obtain the rectification of inaccurate or incomplete personal data (Art. 16 GDPR).",
          "Under certain circumstances, you have the right to demand that personal data relating to you be erased (Art. 17 GDPR)",
          "Under certain circumstances, you have the right to demand the restriction of the processing of your personal data (Art. 18 GDPR).",
          "Under certain conditions, you have the right to receive the personal data concerning you and provided to us by you in a structured, commonly used, and machine-readable format, and the right to transmit those data to another controller or have them transmitted to us (Art. 20 GDPR).",
          "You have the right to lodge a complaint with a supervisory authority, in particular in the EU Member State of your habitual residence, place of work, or place of the alleged infringement, if you consider that the processing of personal data relating to you infringes the GDPR (Art. 77 GDPR).",
          "If the processing of your personal data is subject to your consent (point [a] of Art. 6 [1] GDPR or point [a] of Art. 9 [2] GDPR), you have the right to revoke your consent at any time (Art. 7 [3] GDPR). The withdrawal of consent shall not affect the lawfulness of the data processing performed prior to the withdrawal of consent.",
          "You have the right to object to a decision based solely on automated processing, including profiling, that produces legal effects concerning you or similarly significantly affecting you (Article 22 [1] GDPR).",
          "Under certain circumstances, you have the right to object to the processing of your personal data (Art. 21 GDPR). This right to object exists in particular in cases in which we process your personal data on the legal basis as per the first sentence of point (f) Art. 6 (1) GDPR.",
        ],
        footer: "We do not use any automated processing (Art. 22 GDPR) to make decisions concerning you, including profiling, that produce legal effects concerning you or similarly significantly affecting you.\nTo exercise your rights, please provide us with the scan ID you received on the day of the scan.",
      },
    },

    meta: {
      date: "Date: 1/29/2026",
      version: "Version: 2.8",
    },
  },
};
